var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{staticClass:"overlay-wrapper-container"},[_c('div',{staticClass:"overlay"},[_c('scale-loader',{attrs:{"loading":true,"height":"50px","width":"15px"}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }